export const headerItems = [
  {
    name: 'Catalog',
    link: '#catalog',
  },
  {
    name: 'About us',
    link: '#about',
  },
  {
    name: 'Product selection',
    link: '#selection',
  },
  {
    name: 'Our team',
    link: '#team',
  },
  {
    name: 'FAQ',
    link: '#faq',
  },
  {
    name: 'For staff',
    link: '/staff',
  },
];

export const footerItems = [
  {
    name: 'Catalog',
    link: '#catalog',
  },
  {
    name: 'About us',
    link: '#about',
  },
  {
    name: 'Product selection',
    link: '#selection',
  },
  {
    name: 'Our team',
    link: '#team',
  },
  {
    name: 'FAQ',
    link: '#faq',
  },
];
